export const namespace = 'COMMON'

export const types = {
  SET_LOADED: 'setLoaded',
  SET_LOADING: 'setLoading',
  MOVE_ANCHOR: 'moveAnchor',
  SET_WEB_OPTIMUM_ALARM: 'setWebOptimumAlarm',
  SET_FOOTER_RECT: 'setFooterRect',
  SET_MOBILE: 'setMobile',
  SET_WINDOW_WIDTH: 'setWindowWidth'
}

const state = {
  loaded: false,
  loading: false,
  movedAnchor: false,
  opendWebOptimumAlarm: false,
  footerRect: null,
  isMobile: false,
  windowWidth: 0
}

const mutations = {
  [types.SET_LOADED](state, payload) {
    state.loaded = payload
  },
  [types.SET_LOADING](state, payload) {
    state.loading = payload
  },
  [types.MOVE_ANCHOR](state, payload) {
    if (state.movedAnchor || payload == '' || payload.startsWith('##')) {
      return
    }
    const anchorElement = document.querySelector(payload)
    if (!!anchorElement === false) return
    anchorElement.scrollIntoView()
  },
  [types.SET_WEB_OPTIMUM_ALARM](state, payload) {
    state.opendWebOptimumAlarm = payload
  },
  [types.SET_FOOTER_RECT](state, payload) {
    state.footerRect = payload
  },
  [types.SET_MOBILE](state, payload) {
    state.isMobile = payload
  },
  [types.SET_WINDOW_WIDTH](state, payload) {
    state.windowWidth = payload
  }
}

const actions = {}

export const commonStore = {
  state,
  mutations,
  actions,
  namespace,
  types
}
